var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.29,
    height: 25.594,
    viewBox: "0 0 13.29 25.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2452",
    "data-name": "Group 2452",
    transform: "translate(-37.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f_1_",
    d: "M45.917,25.594V13.92h3.917l.588-4.551h-4.5V6.464c0-1.317.364-2.215,2.255-2.215H50.58V.178A32.648,32.648,0,0,0,47.071,0C43.6,0,41.219,2.12,41.219,6.014V9.369H37.29V13.92h3.929V25.594Z",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.e5549d95e2963246ead143e1d9829946.svg";
export { ForwardRef as ReactComponent };